import { instance } from './instance';
import { CurrentUser } from '@/dashboard/types/current_user';
import { ApiResponseWithData } from '@/dashboard/api/types/apiTypes';

export const AccountApi = {
  getCurrentUser: async (): Promise<ApiResponseWithData<{ user: CurrentUser }>> => {
    const response = await instance.get('/app/account/current');
    return response.data;
  },
  updateCurrentUserSettings: async (data: UpdateCurrentUserProps): Promise<UpdateCurrentUserSettingsResponse> => {
    const { email, name, currentPassword, password, passwordConfirmation } = data;
    const formData = new FormData();

    formData.append('name', name ?? '');
    formData.append('email', email ?? '');

    if (password) {
      formData.append('current_password', currentPassword ?? '');
      formData.append('password', password);
      formData.append('password_confirmation', passwordConfirmation ?? '');
    }
    const response = await instance.post(`/app/account/update_settings`, formData);
    return response.data;
  },
  updateCurrentUserAvatar: async (file: File): Promise<ApiResponseWithData<{ user: CurrentUser }>> => {
    const formData = new FormData();
    formData.append('avatar', file);
    const response = await instance.post(`/app/account/upload_avatar`, formData);
    return response.data;
  },
  removeCurrentUserAvatar: async (): Promise<ApiResponseWithData<{ user: CurrentUser }>> => {
    const response = await instance.post(`/app/account/remove_avatar`);
    return response.data;
  },
  deleteAccount: async () => {
    await instance.post(`/users/delete_user`);
  },
};

export interface UpdateCurrentUserProps {
  name?: string;
  email?: string;
  currentPassword?: string;
  password?: string;
  passwordConfirmation?: string;
}
export type UpdateCurrentUserSettingsResponse = ApiResponseWithData<{
  user?: CurrentUser;
  letter_send?: boolean;
  errors?: Record<string, string[]>;
}>;
